import React from "react";
import { motion } from "framer-motion";
import { getDisplayName } from "../../utils/userDisplayName";

const VoterAvatars = ({ voters, maxDisplay = 5 }) => {
  const displayedVoters = voters.slice(0, maxDisplay);
  const remainingCount = voters.length - maxDisplay;

  return (
    <div className="tw-flex tw-items-center">
      <div className="tw-flex -tw-space-x-2">
        {displayedVoters.map((voter, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{
              duration: 0.2,
              delay: index * 0.1,
              ease: "easeOut",
            }}
            className="tw-group tw-relative tw-h-8 tw-w-8 tw-overflow-hidden tw-rounded-full tw-border-2 tw-border-white"
          >
            <img
              src={voter.avatar_url}
              alt={getDisplayName(voter)}
              className="tw-h-full tw-w-full tw-object-cover"
              loading="lazy"
            />
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              whileHover={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.2 }}
              className="tw-group-hover:tw-visible tw-invisible tw-absolute tw-bottom-full tw-left-1/2 tw-z-10 -tw-translate-x-1/2 -tw-translate-y-2 tw-transform tw-whitespace-nowrap tw-rounded-lg tw-bg-black/75 tw-px-2 tw-py-1 tw-text-xs tw-text-white tw-backdrop-blur-sm"
            >
              {getDisplayName(voter)}
            </motion.div>
          </motion.div>
        ))}
        {remainingCount > 0 && (
          <motion.div
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.2, delay: displayedVoters.length * 0.1 }}
            className="tw-group tw-relative tw-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-full tw-border-2 tw-border-white tw-bg-gray-100"
          >
            <span className="tw-text-xs tw-font-medium tw-text-gray-600">+{remainingCount}</span>
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              whileHover={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.2 }}
              className="tw-group-hover:tw-visible tw-invisible tw-absolute tw-bottom-full tw-left-1/2 tw-z-10 -tw-translate-x-1/2 -tw-translate-y-2 tw-transform tw-whitespace-nowrap tw-rounded-lg tw-bg-black/75 tw-px-2 tw-py-1 tw-text-xs tw-text-white tw-backdrop-blur-sm"
            >
              {remainingCount} more {remainingCount === 1 ? "person" : "people"}
            </motion.div>
          </motion.div>
        )}
      </div>
    </div>
  );
};

export default VoterAvatars;
